<div data-field-span="2" style="border-right: 1px solid black">
  <label>{{ displayName }}</label>
  <label
    ><input
      type="checkbox"
      [checked]="isAboard"
      (change)="emitAboardChange($event)"
    />&nbsp;Aboard</label
  >
  <ng-container
    *ngIf="isAboard && enableNvg"
    [formGroup]="crewMemberAboard"
    class="crew-nvg-container"
  >
    <label
      ><input
        type="checkbox"
        formControlName="isNvg"
        (change)="crewMemberNvgChanged($event)"
      />&nbsp;NVG</label
    >
    <ng-container
      *ngIf="
        (isSimple || (features.crewMemberHnvgo && !isPilot)) && isCrewMemberNvgSelected$ | async
      "
    >
      <label class="hnvgo-lbl">HNVGO</label
      ><input type="number" min="1" step="1" formControlName="hnvgo" class="hnvgo" />
    </ng-container>
  </ng-container>
  <fl-message-box [messages]="crewMemberErrors$ | async" [level]="'error'"></fl-message-box>
</div>
